// CosmicIcon — 1:1 SVG+SMIL port of the app's cosmic_icon.dart (AtomPainter):
// a gradient core sphere + soft glow with 6 electrons orbiting two tilted (±45°)
// elliptical paths on a 6s loop. Shared by the bottom-nav FAB and the remedy
// quiz loading screen.

const ORBIT_BIG = "M -4 50 a 54 29 0 1 0 108 0 a 54 29 0 1 0 -108 0";
const ORBIT_SMALL = "M 4 50 a 46 27 0 1 0 92 0 a 46 27 0 1 0 -92 0";
const BIG_ELECTRONS = [
  { c: "#FFD700", begin: "-5.33s" },
  { c: "#2EDF37", begin: "-0.10s" },
  { c: "#FFFFFF", begin: "-0.86s" },
  { c: "#FFABAB", begin: "-3.29s" },
];
const SMALL_ELECTRONS = [
  { c: "#7474F5", begin: "-2.52s" },
  { c: "#E0E0E0", begin: "-5.81s" },
];

const Electron = ({
  color,
  begin,
  path,
}: {
  color: string;
  begin: string;
  path: string;
}) => (
  <circle cx={0} cy={0} r={5} fill={color}>
    <animateMotion dur="6s" repeatCount="indefinite" begin={begin} path={path} />
  </circle>
);

export default function CosmicIcon({
  size = 50,
  className,
}: {
  size?: number;
  className?: string;
}) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="-12 -12 124 124"
      aria-hidden="true"
      style={{ overflow: "visible", display: "block" }}
    >
      <defs>
        <linearGradient id="auraCoreGrad" x1="0" y1="1" x2="1" y2="0">
          <stop offset="0" stopColor="#01246B" />
          <stop offset="0.2" stopColor="#223CCE" />
          <stop offset="0.4" stopColor="#7D5AC8" />
          <stop offset="0.6" stopColor="#BC5596" />
          <stop offset="0.7" stopColor="#EA5684" />
          <stop offset="1" stopColor="#FC8E64" />
        </linearGradient>
        <radialGradient id="auraGlow">
          <stop offset="0" stopColor="#FFE067" stopOpacity="0.55" />
          <stop offset="0.6" stopColor="#FE6C07" stopOpacity="0.3" />
          <stop offset="1" stopColor="#FE6C07" stopOpacity="0" />
        </radialGradient>
      </defs>

      <circle cx="50" cy="50" r="56" fill="url(#auraGlow)" />
      <circle cx="50" cy="50" r="37" fill="url(#auraCoreGrad)" />

      <g transform="rotate(-45 50 50)">
        <path
          d={ORBIT_BIG}
          fill="none"
          stroke="rgba(255,255,255,0.55)"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        {BIG_ELECTRONS.map((e, i) => (
          <Electron key={`b${i}`} color={e.c} begin={e.begin} path={ORBIT_BIG} />
        ))}
      </g>
      <g transform="rotate(45 50 50)">
        <path
          d={ORBIT_SMALL}
          fill="none"
          stroke="rgba(255,255,255,0.55)"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        {SMALL_ELECTRONS.map((e, i) => (
          <Electron key={`s${i}`} color={e.c} begin={e.begin} path={ORBIT_SMALL} />
        ))}
      </g>
    </svg>
  );
}
